"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.login = login;
exports.getInfo = getInfo;
exports.logout = logout;

var _request = _interopRequireDefault(require("@/utils/request"));

function login(data) {
  console.log(data);
  return (0, _request.default)({
    url: '/user/login',
    method: 'post',
    data: data
  });
}

function getInfo(token) {
  return (0, _request.default)({
    url: '/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}

function logout() {
  return (0, _request.default)({
    url: '/user/logout',
    method: 'post'
  });
}